import React from 'react';
import shallowCompare from '../../../lib/shallowCompare';
import InventoryRecordListElement from '../../InventoryRecordListElement';
import Collection from '../../../models/Collection';

class CollectionItem extends React.Component {
  static propTypes = {
    item: React.PropTypes.object.isRequired,
    collection: React.PropTypes.instanceOf(Collection).isRequired,
    storeId: React.PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickBuyButton(inventoryRecord) {
    this.props.onBuy(this.props.item);
  }

  render() {
    if(!this.props || !this.props.item) {return null;}
    let props = {
      inventoryRecord: this.props.item.inventory_record,
      storeId: this.props.storeId,
      collectionSlug: this.props.collection.slug,
      bookmarkMetadata: {collectionId: this.props.collection.id}
    };
    return <InventoryRecordListElement {...props} />;
  }
}

export default CollectionItem;



// WEBPACK FOOTER //
// banquet/components/CollectionDetail/CollectionItem/index.js